export function positionBotTarget(
  botTarget: HTMLDivElement,
  clickTarget: HTMLDivElement,
) {
  // Move the div to the same place as the target.
  const { top, left } = clickTarget.getBoundingClientRect();

  botTarget.style.top = `${top || 0}px`;
  botTarget.style.left = `${left || 0}px`;
}
